import { render, staticRenderFns } from "./TagRadio.vue?vue&type=template&id=81f8c13c&scoped=true"
import script from "./TagRadio.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagRadio.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f8c13c",
  null
  
)

export default component.exports